// @flow
import { connect } from 'react-redux'
import PlacementTypeSelect, { type Props } from './PlacementTypeSelect'
import type { Store } from '../../redux/ducks'
import { patch } from '../AudienceEditContainer'
import type { PlacementType } from './PlacementTypeSelect'
import store from '../../redux/store'
import { getDefaultFbPlacements } from './fbPlacements'
import type { State as AudienceState } from '../../redux/ducks/audienceEdit/reducers'
import { Audience, carouselProvidersSet, videoProvidersSet } from '../constants'
import _ from 'lodash'

type OwnProps = {|
  onChange: () => void
|}

function mapStateToProps(state: Store) {
  const audienceState = state.audienceEdit

  if (!audienceState.initial) return { options: [], value: [], multi: false }
  return {
    options: audienceState.initial.placementType.options,
    value: audienceState.placementTypes,
    multi: state.segmentation.segmentByPlacementType
  }
}

function mapDispatchToProps(dispatch: Function, ownProps: OwnProps) {
  return {
    onChange: (placementTypes: Array<PlacementType>) => {
      const state: Store = store.getState()
      const audienceState = state.audienceEdit
      const { platform, audienceType } = audienceState
      const placementType = placementTypes[0]

      patch(dispatch, {
        placementTypes,
        fbPlacements: getDefaultFbPlacements(placementType, audienceType, platform),
        vkPlacement: ensureCorrectVkPlacement(audienceState, placementType),
        providers: ensureCorrectProviders(audienceState, placementType),
        providersInfo: ensureCorrectProvidersInfo(audienceState, placementType)
      })
      ownProps.onChange()
    }
  }
}

function ensureCorrectVkPlacement(
  audienceState: AudienceState,
  placementType: PlacementType
): string {
  const { vkPlacement } = audienceState
  return vkPlacement === Audience.vk_placements.promopost_without_public &&
    placementType === Audience.placement_types.with_video
    ? Audience.vk_placements.promopost_with_button
    : vkPlacement
}

function ensureCorrectProviders(
  audienceState: AudienceState,
  placementType: PlacementType
): Array<string> {
  const providersSet = allowedProvidersSet(audienceState, placementType)
  return _.intersection(audienceState.providers, providersSet)
}

function ensureCorrectProvidersInfo(
  audienceState: AudienceState,
  placementType: PlacementType
): Array<Object> {
  const providersSet = allowedProvidersSet(audienceState, placementType)
  return _.filter(audienceState.initial ? audienceState.initial.providers.info : [], (info) => {
    return _.includes(providersSet, info.id)
  })
}

function allowedProvidersSet(
  audienceState: AudienceState,
  placementType: PlacementType
): Array<string> {
  switch (placementType) {
    case Audience.placement_types.with_video:
      return videoProvidersSet
    case Audience.placement_types.carousel:
      return carouselProvidersSet
    default:
      return audienceState.initial
        ? _.map(audienceState.initial.providers.info, (info) => info.id)
        : []
  }
}

const PlacementTypeSelectContainer = connect<Props, OwnProps, _, _, _, _>(
  mapStateToProps,
  mapDispatchToProps
)(PlacementTypeSelect)

export default PlacementTypeSelectContainer
